/**
 * Formatação dos códigos do serviço para exibição. O cadastro grava só
 * dígitos; nas telas cada código aparece separado e no formato que o usuário
 * encontra nos portais (Receita, Sefin, NFS-e Nacional), sem descrição — a
 * descrição textual não tem fonte única entre os sistemas.
 */

const digitsOf = (value: unknown) => (value ?? "").toString().replace(/\D/g, "");

/** Item LC 116: 070602 → 07.06.02, 1711 → 17.11. */
export function formatarItemLc116(codigo: unknown): string {
  const digits = digitsOf(codigo);
  if (digits.length === 4) return `${digits.slice(0, 2)}.${digits.slice(2)}`;
  if (digits.length !== 6) return digits;
  return `${digits.slice(0, 2)}.${digits.slice(2, 4)}.${digits.slice(4)}`;
}

/** CNAE: 4330402 → 4330-4/02. */
export function formatarCnae(cnae: unknown): string {
  const digits = digitsOf(cnae);
  if (digits.length !== 7) return digits;
  return `${digits.slice(0, 4)}-${digits.slice(4, 5)}/${digits.slice(5)}`;
}
